import React, { Fragment } from 'react';
import { assoc } from 'ramda';

import http from 'api/http';
import { manufacturerAPI } from 'api/requests';

import { debounce } from 'helpers';

import { ROLES } from 'constants/roles';

import Slider from 'Components/Slider';
import { Input } from 'Components/Input';

class CertificationSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isCapacityTagLoading: true,
      isNmma: null,
      supplier: null,
    };
  }

  componentDidMount() {
    http
      .get(manufacturerAPI.capacityTagStatus)
      .then(({ data: { isNmma, supplier } }) => this.setState({ isCapacityTagLoading: false, isNmma, supplier }))
      .catch(() => this.setState({ isCapacityTagLoading: false }));
  }

  saveCapacityTagInfo = debounce(() =>
    http.post(manufacturerAPI.capacityTagStatus, {
      mnfCode: this.props.user.selectedManufacturer.code,
      supplier: this.state.supplier,
      isNmma: this.state.isNmma,
    })
  );

  onChangeCapacityTagInfo = (fieldName, fieldValue) => {
    this.setState(assoc(fieldName, fieldValue));
    this.saveCapacityTagInfo();
  };

  render() {
    const { currentYearInfo, toggleCertificationStatus, user } = this.props;
    const { isCapacityTagLoading, isNmma, supplier } = this.state;

    const isBoatManufacturer = user.activeRole.serverName === ROLES.BOAT_MANUFACTURER.serverName;

    const getCertifiedIconClass = () => {
      const roleName = user.getRoleName();

      if (currentYearInfo.isCertified) {
        return roleName === ROLES.TRAILER_MANUFACTURER.readableName
          ? '__nmma-certified-icon'
          : '__nmma-certified-ABYC-icon';
      } else {
        return roleName === ROLES.TRAILER_MANUFACTURER.readableName
          ? '__nmma-not-certified-icon'
          : '__nmma-not-certified-ABYC-icon';
      }
    };

    const getCertifiedStatusClass = () =>
      `summary-scene__certification-text summary-scene__certification-text_${
        currentYearInfo.isCertified ? 'certified' : 'not-certified'
      }`;

    return (
      <section className='scene_section _padding_top_15 _padding_bottom_20'>
        <div className='summary_certification_column'>
          <div>
            <div className={getCertifiedIconClass()} />
            <div className={getCertifiedStatusClass()}>
              {currentYearInfo.isCertified ? 'Certified' : 'Certification Pending'}
            </div>
          </div>
          {user.isInternal() && (
            <Slider
              mainWrapperClassName={`_margin_top_20 ${currentYearInfo.isCertified ? 'green' : ''}`}
              state={!currentYearInfo.isCertified}
              label='Certification'
              toggleAction={toggleCertificationStatus}
            />
          )}
        </div>
        {isBoatManufacturer && (
          <div className='summary_certification_column'>
            {isCapacityTagLoading
              ? (
                <div className='ect-spinner _margin_top_40'>
                  <div className='ect-spinner__image' />
                </div>
              )
              : (
                <Fragment>
                  <Input
                    label='Capacity Tag Supplier'
                    placeholder='Supplier...'
                    inputClassName='input__input-field_primary'
                    onChange={value => this.onChangeCapacityTagInfo('supplier', value)}
                    value={supplier}
                    disabled={!user.isInternal()}
                  />
                  <Slider
                    mainWrapperClassName={`_margin_top_20 ${isNmma ? 'green' : ''}`}
                    state={!isNmma}
                    label='NMMA as Supplier'
                    toggleAction={() => this.onChangeCapacityTagInfo('isNmma', !isNmma)}
                    disabled={!user.isInternal()}
                  />
                </Fragment>
              )}
          </div>
        )}
      </section>
    );
  }
}

export default CertificationSection;



// WEBPACK FOOTER //
// ./src/app/Scenes/SummaryScene/Certification.jsx